import React from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const SCOPE_OPTIONS = [
  { key: 'medical_documents', translationKey: 'medical_documents' },
  // { key: 'health_reports', translationKey: 'health_reports' }, // Commented out - not included in share links
  { key: 'health_interviews', translationKey: 'health_interviews' },
  // { key: 'health_summaries', translationKey: 'health_summaries' }, // Commented out for now
  { key: 'biomarkers', translationKey: 'biomarkers' },
  { key: 'skin_moles', translationKey: 'skin_moles' },
];

const ScopeCheckboxes = ({ scopes, onChange, disabled = false }) => {
  const { t } = useTranslation();

  const handleScopeChange = (key, checked) => {
    const newScopes = { ...scopes, [key]: checked };
    onChange(newScopes);
  };

  return (
    <div className='d-flex flex-column gap-2'>
      {SCOPE_OPTIONS.map(({ key, translationKey }) => (
        <Form.Check
          key={key}
          type='checkbox'
          id={`scope-${key}`}
          label={t(`shared-access.scopes.${translationKey}`)}
          checked={scopes[key] || false}
          onChange={(e) => handleScopeChange(key, e.target.checked)}
          disabled={disabled}
        />
      ))}
    </div>
  );
};

export default ScopeCheckboxes;

